__turbopack_context__.v({
  "activeFilters": "styles-module-scss-module__h0uU-a__activeFilters",
  "count": "styles-module-scss-module__h0uU-a__count",
  "filterTypes": "styles-module-scss-module__h0uU-a__filterTypes",
  "filtersDesktop": "styles-module-scss-module__h0uU-a__filtersDesktop",
  "programCount": "styles-module-scss-module__h0uU-a__programCount",
  "programsContainer": "styles-module-scss-module__h0uU-a__programsContainer",
  "programsRoot": "styles-module-scss-module__h0uU-a__programsRoot",
});
